/**
 * Status Badge Component
 * Reusable color-coded status display
 */

export default function StatusBadge({ status, size = 'md' }) {
  const statusColors = {
    pending: 'bg-yellow-100 text-yellow-800',
    confirmed: 'bg-blue-100 text-blue-800',
    completed: 'bg-green-100 text-green-800',
    cancelled: 'bg-red-100 text-red-800',
    no_show: 'bg-gray-100 text-gray-800'
  };

  const statusLabels = {
    pending: 'Pending',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled',
    no_show: 'No Show'
  };

  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    md: 'px-2.5 py-0.5 text-xs'
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${
        statusColors[status] || 'bg-gray-100 text-gray-800'
      } ${sizeClasses[size]}`}
    >
      {statusLabels[status] || status}
    </span>
  );
}
